module.exports = __webpack_public_path__ + "img/Realisme_Naturalismen_Gengangere.25c964c7.jpg";